import React, { useState } from "react";
import Pagination from "react-js-pagination";

function Paginations({ handlePage, page, total }) {
  const [counter, setCounter] = useState(page);

  const onChangeHandler = (value) => {
    setCounter(value);
    handlePage(value);
  };
  return (
    <>
      <div className="d-flex justify-content-end">
        <Pagination
          itemClass="page-item"
          linkClass="page-link"
          itemsCountPerPage={10}
          activePage={Number(counter)}
          totalItemsCount={Number(total)}
          pageRangeDisplayed={5}
          onChange={onChangeHandler}
        />
      </div>
    </>
  );
}

export default Paginations;
